module.exports = __webpack_public_path__ + "static/media/Dwight.25c86748.png";